import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeavePlan from "../..";
import { instance } from "../../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../../Actions/LanguageAction";
import FloatValues from "../../../../../../../../Component/FloatValues";
import { ReducersTypes } from "../../../../../../../../Constants";
import { Validation } from "../../../Validation";
import ClubLeave from "../../Common/ClubLeave";
import ImportantHoliday from "../../Common/ImportantHolidays";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
let allmonths = moment.monthsShort();
let monthlyallocate = allmonths.map((month) => ({
  monthid: Number(month) + 1,
  name: allmonths[month],
  value: 0,
}));

const ParentState = {
  leavename: null,
  leaveid: null,
  annualbalance: 1,
  monthlyallocate,
  isbalance: true,
};
class BirthdayLeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  validateNext = () => {
    const [isError, errorMessage] = Validation(
      this.state.leavetypeid,
      this.state.ParentIndex,
    );
    if (!isError) {
      this.props.click();
    } else {
      this.props.enqueueSnackbar(errorMessage, { variant: "error" });
    }
  };

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    this.SetValues(this.props);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState(
        {
          ParentIndex,
          leavename: props.InitLeavesPolicy.policy[ParentIndex].leavename,
          leavetypeid: props.leavetypeid,
          annualbalance:
            props.InitLeavesPolicy.policy[ParentIndex].annualbalance,
        },
        () => {
          if (this.state.annualbalance > 0) {
            this.setState({ isbalance: true });
          }
          if (props.InitLeavesPolicy.policy[ParentIndex].monthlyallocate) {
            const array1 =
              props.InitLeavesPolicy.policy[ParentIndex].monthlyallocate;
            if (array1) {
              monthlyallocate.forEach((data) => {
                const month = array1.find((x) => x.monthid == data.monthid);
                if (month) {
                  data.value = month.value;
                }
              });
              this.setState({ monthlyallocate });
            }
          }
        },
      );
    } else {
      const parentIndex = props.ParentIndex || 0;
      const name = get(props, `InitLeavesPolicy.details[${parentIndex}]`, "");
      this.setState({
        ...ParentState,
        leavename: name && get(name, "leavetypename", ""),
      });
    }
  }

  componentWillReceiveProps(props) {
    this.props.onRef({
      onNext: this.validateNext,
    });
    if (this.state.ParentIndex != props.ParentIndex) {
      window.scrollTo(0, 0);
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "isbalance": {
        this.setState({ isbalance: arg[0], annualbalance: 0 }, () => {
          allmonths = moment.monthsShort();
          monthlyallocate = allmonths.map((month) => ({
            monthid: Number(month) + 1,
            name: allmonths[month],
            value: 0,
          }));
          this.setState({ monthlyallocate }, () => this.UpdateReducer());
        });
        break;
      }
      default:
        break;
    }
  }

  calculateBalance = () => {
    let balance = 0;
    for (const month of this.state.monthlyallocate) {
      balance = month.value + balance;
    }
    return balance;
  };

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      leavename: this.state.leavename,
      isbalance: this.state.isbalance,
      annualbalance: this.state.annualbalance,
      // annualbalance: this.state.isbalance ? this.state.annualbalance : this.calculateBalance(),
      monthlyallocate: this.state.monthlyallocate,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    // const numbers = /^[0-9]+$/;
    // if (event.target.value.match(numbers)) {
    let value;
    if (
      Number(event.target.value) > Number(max) ||
      Number.isNaN(event.target.value)
    ) {
      value = this.state[name];
    } else value = Number(event.target.value);
    this.setState({ [name]: value }, () => {
      if (name != "annualbalance") {
        this.UpdateReducer();
      } else {
        const { monthlyallocate } = this.state;
        const eachMonth = this.state.annualbalance / 12;
        for (const month of monthlyallocate) {
          month.value = eachMonth;
        }
        this.setState({ monthlyallocate }, () => {
          this.UpdateReducer();
        });
      }
    });
    // }
  };

  onNameChange(event) {
    this.setState({ leavename: event.target.value });
    if (this.props.ChangeSteppername) {
      this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
    }
  }

  checkUnique() {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    const { ParentIndex, leavename } = this.state;
    if (leavename || leavename != "") {
      if (
        leavename.includes("employeename") ||
        leavename.includes("employeecode") ||
        leavename.includes("designation") ||
        leavename.includes("department") ||
        leavename.includes("businessunit")
      ) {
        enqueueSnackbar("Please enter valid leave name", {
          variant: "error",
        });
        this.setState({ notUnique: true }, () => {
          if (
            this.props.InitLeavesPolicy.policy[ParentIndex] &&
            this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
          ) {
            this.UpdateReducer();
          }
        });
      } else if (
        this.props.InitLeavesPolicy.policy[ParentIndex]
            && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
      ) {
        this.UpdateReducer();
      } else {
        instance
          .post("/leaves/uniqueleavename", {
            leavename,
            leavetypeid: InitLeavesPolicy.details[ParentIndex].leavetypeid,
            leavecategoryid:
              InitLeavesPolicy.details[ParentIndex].leavecategoryid,
            leaveid: this.props.InitLeavesPolicy.policy[ParentIndex]
              ? this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
              : null,
          })
          .then(() => {
            this.setState({ notUnique: false }, () => this.UpdateReducer());
          })
          .catch((error) => {
            this.setState({ notUnique: true });
            enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              {
                variant: "error",
              },
            );
          });
      }
    } else {
      this.setState({ notUnique: true }, () => {
        if (
          this.props.InitLeavesPolicy.policy[ParentIndex] &&
          this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
        ) {
          this.UpdateReducer();
        }
      });
    }
  }

  render() {
    const { InitLeavesPolicy } = this.props;
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div
          className={classNames(
            InitLeavesPolicy.isviewmode
              ? "disable-leavepolicy padding-bottom-30 leave_policy_form"
              : "padding-bottom-30 leave_policy_form",
          )}
        >
          <div className="inner-wrapper opaque">
            <p className="form-main-header">
              <FormattedMessage
                id="LbHourlyLeaveName"
                defaultMessage="Let's give this leave a name"
              />
            </p>
            <div className="form-group">
              <div>
                {/* <input type="text"
                                    class="form-control"
                                    autofocus placeholder="Leave Name"
                                    maxLength={50}
                                    onChange={this.onNameChange.bind(this)}
                                    value={this.state.leavename}
                                    onBlur={this.checkUnique.bind(this)}
                                /> */}
                <TextField
                  className="form-control"
                  placeholder="Leave Name"
                  margin="dense"
                  variant="outlined"
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.leavename}
                  onBlur={this.checkUnique.bind(this)}
                  inputProps={{ maxLength: 50 }}
                />
                {this.state.notUnique ? (
                  <span className="caption-error leave-policy-error">
                    This doesn&apos;t look like a valid leave name
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="inner-wrapper opaque">
            <p className="form-main-header">
              <FormattedMessage
                id="LbLeaveAllocation"
                defaultMessage="Leave Allocation"
              />
            </p>
            <div className="">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbAutoAllocate"
                  defaultMessage="How many birth day leave want to allocate in a year?"
                />
              </p>

              <FloatValues
                min="0.5"
                max="365"
                step="0.5"
                field="annualbalance"
                onChange={this.CommonNumberChange.bind(
                  this,
                  "annualbalance",
                  365,
                )}
                value={this.state.annualbalance}
                defaultvalue={this.state.annualbalance}
              />
            </div>
          </div>
          <ImportantHoliday
            ParentIndex={this.state.ParentIndex}
            leavetypeid={this.state.leavetypeid}
          />
          <ClubLeave
            ParentIndex={this.state.ParentIndex}
            leavetypeid={this.state.leavetypeid}
          />
        </div>
      </IntlProvider>
    );
  }
}
BirthdayLeave.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(BirthdayLeave)));
